// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"82f635fa","80":"2431594d","192":"2d395c52","365":"31cede46","651":"bf727a12","909":"fc655516"}[chunkId] + ".chunk.css";
};